import { render, staticRenderFns } from "./bridge_abnormal.vue?vue&type=template&id=254194b5&"
import script from "./bridge_abnormal.vue?vue&type=script&lang=js&"
export * from "./bridge_abnormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports